import { CustomerTiersGridView } from '~/components/customers/tiers';
import { PageContainer } from '~/components/page-container';

export function CustomerTiers() {
	return (
		<PageContainer>
			<CustomerTiersGridView />
		</PageContainer>
	);
}
